import { z } from "zod";
const markdownPageLinkSchema = z.object({
  filepath: z.string().min(1, "Filepath is required"),
  title: z.string().optional().default("Link to Page"),
  description: z.string().optional().default("Link to a page in the guide")
});
const tiptapPageLinkSchema = z.object({
  uid: z.string().min(1, "UID is required"),
  title: z.string().optional().default("Link to Page"),
  description: z.string().optional().default("Link to a page in the guide")
});
const attributesPageLinkSchema = z.union([
  markdownPageLinkSchema,
  tiptapPageLinkSchema
]);
export {
  attributesPageLinkSchema
};
//# sourceMappingURL=attributes.js.map
